import React from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = props => {
  if (props.error) {
    return <div className={`${props.className} pxl-error-message`}>{props.error}</div>;
  }
  return null;
};

ErrorMessage.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string
};

ErrorMessage.defaultProps = {
  className: '',
  error: null
};

export default ErrorMessage;
